<template>
  <AppBody :title="pageTitle" :subtitle="pageSubtitle" :actions="pageActions">
    <v-form
      @submit.prevent="$marketplace_consumidor.filtroConsumidores()"
      class="search-forms"
    >
      <v-row>
        <v-col cols="3">
          <label class="input-labels">Nome</label>
          <v-text-field
            solo
            placeholder="Insira o nome"
            v-model="$marketplace_consumidor.filter.nome"
            type="text"
            data-cy="nome"
            class="textinput"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <label class="input-labels">CPF</label>
          <v-text-field
            solo
            placeholder="Insira o CPF"
            v-model="$marketplace_consumidor.filter.documento"
            type="text"
            data-cy="cpf"
            class="textinput"
            v-mask="['###.###.###-##']"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <label class="input-labels">Passaporte</label>
          <v-text-field
            solo
            placeholder="Insira o passaporte"
            v-model="$marketplace_consumidor.filter.passaporte"
            type="text"
            data-cy="passaporte"
            class="textinput"
            v-mask="'XXXXXXXX'"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <label class="input-labels">Status</label>
          <v-select
            height="48"
            :items="status"
            dense
            solo
            data-cy="status"
            class="textinput"
            item-text="text"
            item-value="value"
            v-model="$marketplace_consumidor.filter.status"
            placeholder="Selecione o status"
            :color="$config.dados.corinputs"
            clear-icon="mdi-close-circle-outline"
            clearable
            @click:clear-icon="clearFilterFields('regional')"
            :item-color="$config.dados.corinputs"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <label class="input-labels">Data da inclusão (inicial)</label>
          <v-text-field
            v-model="$marketplace_consumidor.filter.dataInicio"
            type="tel"
            data-cy="data-inicial"
            class="textinput"
            v-mask="['XX/XX/XXXX']"
            placeholder="dd/mm/aaaa"
            hide-details
            solo
            append-icon="mdi-calendar-blank-outline"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <label class="input-labels">Data da inclusão (final)</label>
          <v-text-field
            v-model="$marketplace_consumidor.filter.dataFim"
            type="tel"
            data-cy="data-final"
            class="textinput"
            v-mask="['XX/XX/XXXX']"
            placeholder="dd/mm/aaaa"
            hide-details
            solo
            append-icon="mdi-calendar-blank-outline"
          ></v-text-field>
        </v-col>
        <v-col cols="6" class="d-flex justify-end">
          <v-col cols="4" class="d-flex align-end pb-0 pr-0">
            <v-btn
              height="48"
              data-cy="filtrar"
              class="button btn-size btn-border"
              type="submit"
              :loading="$marketplace_consumidor.cadastro.loading_consumidores"
            >
              Filtrar
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-form>
    <template>
      <v-switch
        v-model="singleSelect"
        label="Seleção única"
        class="pl-3"
        :color="$config.dados.corinputs"
      >
      </v-switch>
    </template>
    <v-data-table
      v-model="$marketplace_consumidor.select_consumidores"
      no-data-text="Não há registro de consumidores para esta marketplace."
      loading-text="Buscando informações..."
      :headers="headers"
      :items="orderedConsumer"
      :single-select="singleSelect"
      :loading="$marketplace_consumidor.cadastro.loading_consumidores"
      item-key="idconsumidor_marketplace"
      show-select
      class="table-body"
      :items-per-page="10"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: 'Consumidores por página:',
      }"
    >
      <template v-slot:item.ins_dthr="{ item }">
        {{ item.ins_dthr | data_pt_br }}
      </template>
      <template v-slot:item.documento="{ item }">
        {{ item.end_pais === "Brasil" ? item.documento : item.passaporte }}
      </template>
      <template v-slot:item.actions="{ item }" class="table-actions">
        <div style="display: flex; justify-content: center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                width="30"
                small
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="goToConsumer('editar', item)"
                class="mr-2"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                width="30"
                small
                icon
                :disabled="!item.historico_pedidos"
                @click="
                  openModal(
                    'modal-body-pedidos-consumidor',
                    'pedidos',
                    item.idconsumidor_marketplace
                  )
                "
              >
                <v-icon>mdi-cart-outline</v-icon>
              </v-btn>
            </template>
            <span>Pedidos</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status == 'ATIVO'"
                :color="$config.dados.corinputs"
                height="30"
                v-bind="attrs"
                v-on="on"
                width="30"
                small
                icon
                @click="
                  $marketplace_consumidor.desabilitarConsumidor(
                    item.idconsumidor
                  )
                "
              >
                <v-icon>mdi-account-cancel-outline</v-icon>
              </v-btn>
            </template>
            <span>Inativar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status == 'INATIVO'"
                :color="$config.dados.corinputs"
                height="30"
                v-bind="attrs"
                v-on="on"
                width="30"
                small
                icon
                @click="
                  $marketplace_consumidor.habilitarConsumidor(
                    item.idconsumidor_marketplace
                  )
                "
              >
                <v-icon>mdi-account-check-outline</v-icon>
              </v-btn>
            </template>
            <span>Ativar</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <!-- </div> -->
    <ModalPedidosConsumidor />
    <ModalItensPedidoConsumidor />
    <ModalExportarConsumidor />
  </AppBody>
</template>

<script>
import MarketplaceConsumidorMixins from "@/mixins/Marketplace-Consumidor.mixins.js";
import _ from "lodash";
import { ENDPOINTS } from "@/services/Endpoints.js";
export default {
  name: "Consumer",
  mixins: [MarketplaceConsumidorMixins],
  metaInfo: {
    title: "Consumidor | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Consumidor | ElevenTickets",
      },
    ],
  },
  components: {
    ModalPedidosConsumidor: () =>
      import(
        "@/components/marketplace/consumidor/modal-pedidos-consumidor.vue"
      ),
    ModalItensPedidoConsumidor: () =>
      import(
        "@/components/marketplace/consumidor/modal-itens-pedido-consumidor.vue"
      ),
    ModalExportarConsumidor: () =>
      import(
        "@/components/marketplace/consumidor/modal-exportar-consumidor.vue"
      ),
    AppBody: () => import("@/layouts/components/AppBody.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Novo Cadastro",
          action: () => this.goToConsumer("new", ""),
        },
        {
          name: "Exportar",
          action: () => this.openModal("modal-body-consumidor-exportar"),
        },
      ],
      actionLojista: [
        {
          name: "Novo Cadastro",
          action: () => this.goToConsumer("new", ""),
        },
        {
          name: "Exportar",
          action: () => this.openModal("modal-body-consumidor-exportar"),
        },
      ],
      ENDPOINTS: ENDPOINTS,
      Nomemarketplace: "Consumidor",
      modalSelectmarketplace: false,
      activePicker: null,
      activePicker2: null,
      date: null,
      menu: false,
      menu2: false,
      dtInicial: "",
      dtFinal: "",
      placeholderData: "dd/mm/aa",
      marketplace: "",
      singleSelect: false,
    };
  },
  computed: {
    pageTitle() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return "Marketplace / Consumidor";
      return "Marketplace / Consumidor";
    },
    pageSubtitle() {
      if (this.$marketplace_consumidor.marketplace_nome)
        return (
          "Consumidores - " + this.$marketplace_consumidor.marketplace_nome
        );
      return "Consumidores";
    },
    pageActions() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return this.actions;
      return this.actionLojista;
    },
    orderedConsumer() {
      return _.orderBy(
        this.$marketplace_consumidor.consumidores,
        ["status", "ins_dthr"],
        ["asc", "desc"]
      );
    },
  },
  methods: {
    openModal(name, filter, consumidor) {
      if (filter == "pedidos") {
        this.$marketplace_consumidor.loading_pedidos = true;
        this.$axios
          .post(this.ENDPOINTS.LISTAR_PEDIDOS_MARKET, {
            idconsumidor_marketplace: consumidor,
            lang: "pt",
            status: [
              "RE",
              "TP",
              "AA",
              "AP",
              "PA",
              "PC",
              "CA",
              "EX",
              "ER",
              "EP",
            ],
          })
          .then(response => {
            this.$marketplace_consumidor.pedidos = response.pedidos;
            document.getElementsByClassName(name)[0].style.display = "flex";
            this.$marketplace_consumidor.loading_pedidos = false;
          })
          .catch(error => {
            this.$marketplace_consumidor.loading_pedidos = false;
            document.getElementsByClassName(name)[0].style.display = "flex";
            throw new Error(error);
          });
      } else {
        document.getElementsByClassName(name)[0].style.display = "flex";
      }
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.dsc_lang.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    clearFilterFields(field) {
      switch (field) {
        case "status":
          this.$marketplace_consumidor.filter.status = "";
          break;
        case "tipo_pessoa":
          this.$marketplace_consumidor.filter.tipoPessoa = "";
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.$marketplace_consumidor.getAllConsumidores();
  },
  destroyed() {
    this.$marketplace_consumidor.marketplace_selecionada = "";
    this.$marketplace_consumidor.consumidores = [];
    this.$marketplace_consumidor.limpaFiltros();
  },
};
</script>

<style scoped>
.table-actions {
  height: 67px !important;
}

.pessoas-consumidor-container09 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  overflow-x: auto;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.pessoas-consumidor-button08 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 0.625rem;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.pessoas-consumidor-button09 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 0.625rem;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.pessoas-consumidor-icon {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
</style>
